import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import Highlight from "./Highlight";

interface NewsCardProps {
  item: NewsItem;
  keyword?: string;
}

export default function NewsCard({ item, keyword = "" }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer p-4"
    >
      <div className="w-full sm:w-48 h-40 sm:h-32 shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={item.cover}
          alt={`新闻配图：${item.title}`}
          title={`${item.title} - 濑户环奈新闻动态`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-2 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-accent-100 text-accent-800">
            {item.category}
          </span>
          <span className="text-xs text-foreground-500">{item.date}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
          <Highlight text={item.title} keyword={keyword} />
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          <Highlight text={item.summary} keyword={keyword} />
        </p>
      </div>
    </Link>
  );
}